import React, {
  ChangeEvent,
  FormEvent,
  useCallback,
  useEffect,
  useState,
} from "react"
import {
  EducationalRecord,
  EducationalRecordCredentials,
  EmploymentRecord,
  EmploymentRecordCredentials,
  Form,
  OLevelResult,
  OLevelResultCredentials,
  SubjectInterface,
  UploadRecordCredentials,
  stageLevel,
  stages,
  useAppNotificationStore,
  useApplicationStore,
  useAuthStore,
  useProfileStore,
} from "stores"
import {
  Button,
  ChooseFile,
  H4,
  H6,
  IconButton,
  Input,
  Label,
  ModalPortal,
  P1,
  P2,
  SelectInput,
  SelectOption,
  Table,
  TableData,
  TableHeader,
  TextAnchor,
  TextButton,
} from "components"
import { AddCircle, Eye, EyeSlash, Maximize4, Trash } from "iconsax-react"
import { images } from "assets"
import { useNavigate } from "react-router-dom"
import { BASEURL, throttle } from "utils"
import { UploadOlevelResults } from "../UploadOlevelResult"
import EducationalRecordComp from "./EducationalRecord"
import { EmploymentRecordComp } from "./EmploymentRecord"

export const Records: React.FC<{}> = () => {
  const { setDashboardContext, toast } = useAppNotificationStore()
  const navigate = useNavigate()
  const { profile } = useProfileStore()
  const { updateStage } = useApplicationStore()

  const [currentScreen, setCurrentScreen] = useState(0)

  useEffect(() => {
    setDashboardContext("Records")
  }, [setDashboardContext])

  const handleNext = async () => {
    if (
      profile?.nextStage === stages.Admitted ||
      profile?.nextStage === stages.rejected
    ) {
      if (currentScreen < 2) {
        setCurrentScreen(currentScreen + 1)
      } else {
        navigate("/dashboard/registration/picture-upload")
      }
      return
    }
    await updateStage({ currentStage: profile?.nextStage! }).then((resp) => {
      if (resp.isSuccessful === true) {
        if (profile?.nextStage === stages.EducationalRecord) {
          useProfileStore.setState({
            profile: { ...profile, nextStage: stages.OlevelResult },
          })
        }
        if (profile?.nextStage === stages.OlevelResult) {
          useProfileStore.setState({
            profile: { ...profile, nextStage: stages.EmploymentRecord },
          })
        }
        if (profile?.nextStage === stages.EmploymentRecord) {
          useProfileStore.setState({
            profile: { ...profile, nextStage: stages.PictureUpload },
          })
          navigate("/dashboard/registration/picture-upload")
        }
      }
    })
  }

  const handlePrevious = () => {
    if (currentScreen > 0) {
      setCurrentScreen(currentScreen - 1)
    } else {
      navigate("/dashboard/registration/program-choices")
    }
    if (
      profile?.nextStage === stages.Admitted ||
      profile?.nextStage === stages.rejected
    ) {
      // useProfileStore.setState({
      //   profile: { ...profile, nextStage: stages.OlevelResult },
      // })
      navigate("/dashboard/registration/program-choices")
    }
    if (profile?.nextStage === stages.OlevelResult) {
      useProfileStore.setState({
        profile: { ...profile, nextStage: stages.EducationalRecord },
      })
    }
    if (profile?.nextStage === stages.EmploymentRecord) {
      useProfileStore.setState({
        profile: { ...profile, nextStage: stages.OlevelResult },
      })
    }
  }

  return (
    <div className="flex flex-col gap-12 items-center">
      {profile?.nextStage === stages.Admitted ||
      profile?.nextStage === stages.rejected ? (
        <>
          <div className="flex flex-col items-center gap-6">
            <H4 className="font-semibold text-accentText">
              {currentScreen === 1
                ? "School Record"
                : currentScreen === 0
                ? "O'Level Results"
                : currentScreen === 2
                ? "Employment Record"
                : ""}
            </H4>
            <P1 className="text-accentGrey1 text-center">
              Upload your Results, certificates and other proof of record.
            </P1>
          </div>
          {currentScreen === 0 && <UploadOlevelResults />}
          {currentScreen === 1 && <EducationalRecordComp />}
          {currentScreen === 2 && <EmploymentRecordComp />}

          <div className="flex gap-4 justify-end items-center mt-2">
            <Button
              type="button"
              title="Previous"
              color="secondary"
              className="w-52"
              // onClick={() => navigate("/dashboard/registration/program-choices")}
              onClick={() => handlePrevious()}
            >
              Previous
            </Button>
            <Button
              type="button"
              title="Next"
              color="primary"
              className="w-52"
              onClick={() => handleNext()}
            >
              Next
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col items-center gap-6">
            <H4 className="font-semibold text-accentText">
              {profile?.nextStage === stages.EducationalRecord
                ? "School Record"
                : profile?.nextStage === stages.OlevelResult
                ? "O'Level Results"
                : profile?.nextStage === stages.EmploymentRecord
                ? "Employment Record"
                : ""}
            </H4>
            <P1 className="text-accentGrey1 text-center">
              Upload your Results, certificates and other proof of record.
            </P1>
          </div>
          {profile?.nextStage === stages.OlevelResult && (
            <UploadOlevelResults />
          )}
          {profile?.nextStage === stages.EducationalRecord && (
            <EducationalRecordComp />
          )}
          {profile?.nextStage === stages.EmploymentRecord && (
            <EmploymentRecordComp />
          )}

          <div className="flex gap-4 justify-end items-center mt-2">
            <Button
              type="button"
              title="Previous"
              color="secondary"
              className="w-52"
              // onClick={() => navigate("/dashboard/registration/program-choices")}
              onClick={() => handlePrevious()}
            >
              Previous
            </Button>
            <Button
              type="button"
              title="Next"
              color="primary"
              className="w-52"
              onClick={() => handleNext()}
            >
              Next
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
